module.exports = __webpack_public_path__ + "static/media/styledClose.a2c0822f.svg";